import * as React from 'react';

const SvgNewExpert = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 21 19'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#new_expert_svg__a)">
      <path
        d="M6.652 14.366v-.52H.52V1.416h19.395v12.428h-9.898l-.15.135-3.216 2.922v-2.536Z"
        stroke="currentColor"
        strokeWidth={1.041}
      />
      <circle cx={5.728} cy={7.578} r={1.432} fill="currentColor" />
      <circle cx={10.5} cy={7.578} r={1.432} fill="currentColor" />
      <circle cx={15.273} cy={7.578} r={1.432} fill="currentColor" />
    </g>
    <defs>
      <clipPath id="new_expert_svg__a">
        <path fill="currentColor" transform="translate(0 .896)" d="M0 0h21v17.182H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNewExpert;
